import { BookingGroup } from '../../entities/booking-group';
import { MinMax } from '../../entities/min-max';

interface ConstraintValidator {
    target: string;
    object: string;
    attribute: string;
}

export class DepartureDetailsErrorMessage {
    key: string;
    message: string;

    static createFromObject(object: any) {
        let message: DepartureDetailsErrorMessage = new DepartureDetailsErrorMessage();
        message.key = object.key;
        message.message = object.message;
        return message;
    }
}

export class DepartureDetailsErrors {
    vehicle: boolean = false;
    vehicle_type: boolean = false;
    vehicle_id: boolean = false;
    vehicle_reg: boolean = false;
    vehicle_length: boolean = false;
    vehicle_width: boolean = false;
    vehicle_height: boolean = false;
    vehicle_weight: boolean = false;
    drivers: boolean = false;
    contact_email: boolean = false;
    contact_name: boolean = false;
    contact_number: boolean = false;
    total: number = 0;
}

export class DepartureDetailsValidator {
    required: string[] = [
        'vehicle',
        'vehicle_length',
        'vehicle_width',
        'vehicle_height',
        'vehicle_weight',
        'contact_email',
        'contact_name',
        'contact_number',
    ];

    integers: string[] = [];

    numeric: string[] = [
        'vehicle_length',
        'vehicle_width',
        'vehicle_height',
        'vehicle_weight',
    ];

    strings: string[] = [
        'contact_name',
        'contact_email',
        'contact_number',
    ];

    objects: string[] = [
        'vehicle',
        'vehicle_type',
    ];

    constraints: ConstraintValidator[] = [
        {
            target: 'drivers',
            object: 'vehicle_type',
            attribute: 'drivers',
        },
        {
            target: 'vehicle_length',
            object: 'vehicle_type',
            attribute: 'length',
        },
        {
            target: 'vehicle_width',
            object: 'vehicle_type',
            attribute: 'width',
        },
        {
            target: 'vehicle_height',
            object: 'vehicle_type',
            attribute: 'height',
        },
        {
            target: 'vehicle_weight',
            object: 'vehicle_type',
            attribute: 'weight',
        }
    ];

    errors: DepartureDetailsErrors;
    errorMessages: DepartureDetailsErrorMessage[];

    constructor(bookings?: BookingGroup) {
        this.errors = new DepartureDetailsErrors();
        this.errorMessages = [];

        if (bookings === undefined) return;

        if (bookings.vehicle_type !== undefined && bookings.vehicle_type.name.toLowerCase() !== 'droptrailer') {
            this.required.push('vehicle_reg');
            this.strings.push('vehicle_reg');
            this.required.push('drivers');
            this.integers.push('drivers');
        }

        for (let r of this.required) {
            if (bookings[r] === undefined)
                this.pushErrorAttr(r);
        }

        for (let i of this.integers) {
            if (bookings[i] === undefined || isNaN(parseInt(bookings[i])))
                this.pushErrorAttr(i);
        }

        for (let n of this.numeric) {
            if (bookings[n] === undefined || isNaN(parseFloat(bookings[n])))
                this.pushErrorAttr(n);
        }

        for (let s of this.strings) {
            if (bookings[s] === undefined || typeof bookings[s] !== 'string' || bookings[s].length < 1)
                this.pushErrorAttr(s);
        }

        for (let o of this.objects) {
            if (bookings[o] === undefined || typeof bookings[o] !== 'object')
                this.pushErrorAttr(o);
        }

        for (let o of this.constraints) {
            let target: string = o.target;

            let object = o.object;
            let attribute = o.attribute;
            if (
                bookings[object] === undefined ||
                bookings[object][attribute] === undefined ||
                !(bookings[object][attribute] instanceof MinMax)
            ) continue;

            let constraints: MinMax = bookings[object][attribute];
            let targetValue: number = bookings[target];

            if (bookings[target] === undefined) {
                this.pushErrorAttr(target, 'Between ' + constraints.min + ' and ' + constraints.max);
                continue;
            }

            if ((targetValue + '').length === 0 || targetValue < constraints.min || targetValue > constraints.max)
                this.pushErrorAttr(target, 'Between ' + constraints.min + ' and ' + constraints.max);
        }
    }

    private pushErrorAttr(attr: string, error?: string) {
        if (!this.errors[attr]) this.errors.total++;
        this.errors[attr] = true;
        if (error !== undefined && error.length > 0) {
            let message: DepartureDetailsErrorMessage = DepartureDetailsErrorMessage.createFromObject({
                key: attr,
                message: error,
            });
            this.errorMessages.push(message);
        }

    }

    message(key: string): string {
        for (let m of this.errorMessages) {
            if (m.key === key) return m.message;
        }
        return null;
    }

    fails(): boolean {
        return this.errors.total > 0;
    }
}



// WEBPACK FOOTER //
// ./src/validators/departure-details/validator.ts